import api from "./api";

class FacilityService {
  static getAll() {
    return api.get("/facility");
  }

  static getById(id) {
    return api.get(`/facility/${id}`);
  }

  static create(data) {
    return api.post("/facility", data);
  }

  static update(id, data) {
    return api.put(`/facility/${id}`, data);
  }

  static delete(id) {
    return api.delete(`/facility/${id}`);
  }
}

export default FacilityService;
